import React, { FC } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { WidgetsOutlined, SignalCellularAltOutlined, ArticleOutlined } from '@mui/icons-material';


const ReportTypeRenderer: FC<ICellRendererParams> = (props: ICellRendererParams) => {
    const value = props.value?.toLowerCase();
    const iconMap = {
        'duediligence': <ArticleOutlined />,
        'duediligencefinancial': <SignalCellularAltOutlined/>,
    }

    return <div className="icon-renderer-cell">
        {iconMap[value] || <WidgetsOutlined />}
    </div>
};

export default ReportTypeRenderer;